import React, {useState,useEffect, useContext} from "react"
import ComponentGroup from "../ComponentGroup/ComponentGroup"
import {Link} from "gatsby"
import { componentRenderCheck, multiConditionComponentRenderCheck } from "../services/componentRenderCheck"
import {ConditionContext} from "../context/conditionContext"
import {ErrorContext} from "../context/errorContext"
import {JourneyContext} from "../context/journeyContext"
import { RepeatableContext } from "../context/repeatableContext"
import {SectionContext} from "../context/sectionContext"
import * as lookup from "../../../static/lookup.json";
import { DataLayerIntegration } from "../services/helperFunctions"

const Section = props => {
  let validForm = true
  const CPPersonalProceedCondition = (index)=>{
    return index>=4 && props.section.sectionId == "CPPersonalDetailsSection" && validForm
  }
  const [conditionState,setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [journeyState,setJourneyState] = useContext(JourneyContext)
  const [repeatableState,setRepeatableState] = useContext(RepeatableContext)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [showModal, setShowModal] = useState(false);
  // console.log(props,'sectionnnnnnnnnnnnnnnnn');

  const handleAdd = (element) =>{
    let temp = [...repeatableState[element.componentId], element]
    setRepeatableState(prev => {
      return ({
        ...prev,
        [element.componentId]: temp
      })
    })
  }
  const handleEnterAdd = (event,element) =>{
    if(event.key == 'Enter'){
      handleAdd(element)
    }

  }

  const handleEnterRemove = (event,element,index) =>{
    if(event.key == 'Enter'){
      handleRemove(element,index)

    }
  }
  const handleRemove = (element, index) => {
    if(index === 0){
      return 
    }else{
      let temp = repeatableState[element.componentId].filter((groups,i) => {
        return i !== index
      })
      setRepeatableState(prev => {
        return({
          ...prev,
          [element.componentId]: temp
        })
      })

      //removing from section state
      let tempNewSectionState = {}
      console.log(sectionState.sectionData, "checkdcdc")
      Object.keys(sectionState.sectionData).forEach(element => {
        let temp = sectionState.sectionData[element]
        if(Array.isArray(temp)){
          temp.splice(index,1)
        }
        tempNewSectionState[element] =  temp
      })
      console.log(tempNewSectionState, "checkdcdc1")
      setSectionState(prev => {
        return ({
          ...prev,
          sectionData: tempNewSectionState
        })
      })
      //removing from error state
      let tempNewErrorState = {}
      Object.keys(errorState).forEach(element => {
        let temp = errorState[element]
        if(Array.isArray(temp)){
          temp.splice(index,1)
        }
        tempNewErrorState[element] = temp
      })
      console.log(tempNewErrorState, "newErrorState")
      setErrorState(tempNewErrorState)
    }
  }

  const standardCapital = (input)=>{
    if(input){
      var str = input?.split(" "); 
      var expected = "";
      str?.map(function(c){
        expected += c?.toLowerCase()?.replace(/^[a-z]/, c[0]?.toUpperCase())+ " "
      })
      expected = expected?.trim(); 
      return expected;
    }
  }
  //To manage state first repetableStateUpdate
  useEffect(() => {
    // console.log("useEffect", props.section)
    props.section?.component_groups.map((element, i) => {
      if(element.repeatable){
        if(!repeatableState[element.componentId]){
          if (sectionState.sectionData) {
            let repeatableStateLength
            element.components.forEach((comp) => {
              if (sectionState.sectionData[comp.formControlKey]) {
                // console.log(sectionState.sectionData[comp.formControlKey].length, "abcd12", repeatableState[element.componentId].length, "abcd13")
                repeatableStateLength = sectionState.sectionData[comp.formControlKey].length
              }
            })
            console.log(repeatableStateLength, "abcd15")
            if(repeatableStateLength){
              const length = repeatableStateLength
              let arr = []
              for (let i = 0; i < length; i++) {
                arr.push(element)
              }
              setRepeatableState(prev => {
                return ({
                  ...prev,
                  [element.componentId]: arr
                })
              })
            }else{
              setRepeatableState(prev => {
                return ({
                  ...prev,
                  [element.componentId]: [element]
                })
              })
            }
          } 
        }
        // else {
        //   setRepeatableState(prev => {
        //     return ({
        //       ...prev,
        //       [element.componentId]: [element]
        //     })
        //   })
        // }
      }
    })
  }, [props.section])


  const resideneSections = {
    "iSelect360CPResidentAndOccupationDetailSection" : true,
    "youngTermCPResidentAndOccupationDetailSection" : true,
  } 

    useEffect(() => {
      if (resideneSections.hasOwnProperty(sectionState.sectionId) && lookup.NSAP_AGE_PROOF[0].hasOwnProperty(sectionState.sectionData?.prrofIdAge)) {
        setShowModal(true);
      }
      else{
        setShowModal(false)
      }
    }, [sectionState.sectionData?.['prrofIdAge']]);
    
    const closeModal = () => {
      setShowModal(false);
    };

  return (
    <>
      <div className="col-md-9 brd-right">
        <div className="iselect-box-design">
          <div className="heading-design">
            <div className="iselect-padding left-side-head ckyc-w">
              <h1 className="iselect-heading">{props.section ? props.section.name : ""}</h1>
            </div>
            {(props.currentSectionIndex === 0 && props.currentPageIndex === 0) ? (journeyState?.journeyType?.toLowerCase() !== "canarapos") ?
            <Link  state={{channel: journeyState.channel}}  >
              <div className="iselect-padding right-side-resume" aria-hidden="true" onClick={() => {
                let e = ""
                let formControlKey = "click"
                let journeyFormatData = props.applicationDataInJourneyFormat()
                DataLayerIntegration(journeyFormatData,e ,"ResumeApplication",formControlKey, journeyState)
                const randomId = sessionStorage.getItem("x-rid");
                // If randomId exists, this means the login happened via a sales agent,
                // so redirect to the agency resume journey link.
                if (randomId) {
                  window.location.href = `${process.env.GATSBY_RESUME_JOURNEY_LINK}/?rid=${randomId}`;
                } else {
                  window.location.href = process.env.GATSBY_RESUME_JOURNEY_LINK;
                }

                }}>
                <h1 style={{ background: `${journeyState.channel === "A" ? "#ededed" :  "#fff"}` }} >Resume Application</h1> {/*var(--lumiq-bg)*/}
                <p>Continue with your existing application</p>
              </div>
            </Link>
            : "" :
            <div className="app-quatation nri-mt-space hidden-desktop-screen">
              <div className="application-design-number">Application Number: {journeyState.applicationNo}</div>
            </div>
            }
          </div>
          <div className="iselect-padding section-container width100rider">
            <div className="row" >
              {props.section && props.section.component_groups.map((element, i) => {
                // If element is repeatable we are applying a loop to render them
                if (element.repeatable){
                  // console.log("else")
                  // console.log(sectionState.sectionData, element, "abcd1")
                  // let repeatableStateLength 
                  // element.components.forEach((comp) => {
                  //   if(sectionState.sectionData[comp.formControlKey]  && repeatableState[element.componentId] && (sectionState.sectionData[comp.formControlKey].length !== repeatableState[element.componentId].length)){
                  //     console.log(sectionState.sectionData[comp.formControlKey].length, "abcd12", repeatableState[element.componentId].length, "abcd13")
                  //     repeatableStateLength = sectionState.sectionData[comp.formControlKey].length
                  //   }
                  // })
                  // console.log(repeatableStateLength, "abcd15")
                  // if(repeatableStateLength){
                  //   const length = repeatableStateLength
                  //   let arr = []
                  //   for(let i=0; i< length; i++){
                  //     arr.push(element)
                  //   }
                  //   setRepeatableState(prev => {
                  //     return ({
                  //       ...prev,
                  //       [element.componentId]: arr
                  //     })
                  //   })
                  // }

                  if (element.conditions.length === 1){
                    if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                      return (
                        <div key={props.sectionId + i}>
                          {repeatableState[element.componentId] && repeatableState[element.componentId].map((component, index) => {
                            return (
                              <div key={component.componentId + index + i}>
                                <div className="col-md-12 col-xs-12">
                                  {(index !== 0) && (props.sectionId === "nomineeDetailsSection") && <hr className="hr-line space-hr" key={component.componentId + index + i + "break-line"} />}
                                </div>
                                <div className={component.class} key={component.componentId + index + i + "component-group"}>
                                  <ComponentGroup
                                    applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                                    key={component.componentId + index + i}
                                    data={component.components}
                                    sectionId={props.section.sectionId}
                                    pageId={props.pageId}
                                    showError={props.showError}
                                    repeatable={element.repeatable}
                                    index={index}
                                    journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                    channel={journeyState.channel}
                                    firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                    setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                                  ></ComponentGroup>
                                </div>
                                <div className="col-md-12 col-xs-12 text-right">
                                  {(index !== 0) && <span className="provider add-plus-design removeOne" tabIndex="0" onKeyPress={(event) => { handleEnterRemove(event, element, index) }} onClick={() => handleRemove(element, index)} key={component.componentId + index + i + "remove-button"} >Remove -</span>}
                                </div>
                              </div>
                            )
                          })}
                          <div className={"add-plus-design text-right addMore col-md-12 col-xs-12"} key={i + "add-button"}>
                            <span onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} tabIndex="0" > Add Another + </span> </div>
                        </div>
                      )
                    }
                  } else if (element.conditions.length > 1) {
                    if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                      return (
                        <div key={props.sectionId + i}>
                          {repeatableState[element.componentId] && repeatableState[element.componentId].map((component, index) => {
                            return (
                              <div key={component.componentId + index + i}>
                                <div className="col-md-12 col-xs-12">
                                  {(index !== 0) && (props.sectionId === "nomineeDetailsSection") && <hr className="hr-line space-hr" key={component.componentId + index + i + "break-line"} />}
                                </div>
                                <div className={component.class} key={component.componentId + index + i + "component-group"}>
                                  <ComponentGroup
                                    applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                                    key={component.componentId + index + i}
                                    data={component.components}
                                    sectionId={props.section.sectionId}
                                    pageId={props.pageId}
                                    showError={props.showError}
                                    repeatable={element.repeatable}
                                    index={index}
                                    journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                    channel={journeyState.channel}
                                    firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                    setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                                  ></ComponentGroup>
                                </div>
                                <div className="col-md-12 col-xs-12 text-right">
                                  {(index !== 0) && <span className="provider add-plus-design removeOne" tabIndex="0" onKeyPress={(event) => { handleEnterRemove(event, element, index) }} onClick={() => handleRemove(element, index)} key={component.componentId + index + i + "remove-button"} >Remove -</span>}
                                </div>
                              </div>
                            )
                          })}
                          <div className={"add-plus-design text-right addMore col-md-12 col-xs-12"} key={i + "add-button"}>
                            <span onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} tabIndex="0" > Add Another + </span> </div>
                        </div>
                      )
                    }
                  } else {
                    return (
                      <div key={props.sectionId + i}>
                        {repeatableState[element.componentId] && repeatableState[element.componentId].map((component, index) => {
                          return (
                            <div key={component.componentId + index + i}>
                              <div className="col-md-12 col-xs-12">
                                {(index !== 0) && (component.componentId === "nomineePersonalDetail") && <hr className="hr-line space-hr" key={component.componentId + index + i + "break-line"} />}
                              </div>
                              <div className={component.class} key={component.componentId + index + i + "component-group"}>
                                <ComponentGroup
                                  applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                                  key={component.componentId + index + i}
                                  data={component.components}
                                  sectionId={props.section.sectionId}
                                  pageId={props.pageId}
                                  showError={props.showError}
                                  repeatable={element.repeatable}
                                  index={index}
                                  journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                  channel={journeyState.channel}
                                  firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                  setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                                ></ComponentGroup>
                              </div>
                              <div className="col-md-12 col-xs-12 text-right">
                                {(index !== 0) && <span className="add-plus-design removeOne" onKeyPress={(event) => { handleEnterRemove(event, element, index) }} tabIndex="0" onClick={() => handleRemove(element, index)} key={component.componentId + index + i + "remove-button"} >
                                  {component.componentId === "nomineePersonalDetail" ? 'Remove Nominee -' : 'Remove -'}</span>}
                              </div>
                            </div>
                          )
                        })}
                        <div className="provider add-plus-design text-right addMore col-md-12 col-xs-12" key={i + "add-button"} >
                          <span tabIndex="0" onKeyPress={(event) => handleEnterAdd(event, element)} onClick={() => handleAdd(element)} >

                            {
                              props.sectionId === "nomineeDetailsSection"
                                ? 'Add Another Nominee +'
                                : 'Add Another +'}
                          </span>


                        </div>
                      </div>
                    )
                  }
                } else {
                  if (element.conditions.length === 1) {
                    if (componentRenderCheck(element.conditions[0], conditionState[element.conditions[0].watchKey], journeyState)) {
                      if(!props.showFirstSectionFields && props.currentSectionIndex === 0 && props.currentPageIndex === 0){
                        if(element.componentId === "CPPersonalDetailName" || element.componentId ===  "email" || element.componentId ===  "contactNo" || element.componentId === "privacypolicy-MD-12-order-25" || element.componentId === "corporateOtp"){
                          return (
                            <div className={element.class} key={element.componentId + i}> 
                              <ComponentGroup
                              applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                              key={element.componentId  + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              businessRule = {props.businessRule}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              ></ComponentGroup>
                            </div>
                          )
                        }
                      }else{
                        if (element.class){
                          return (
                            <div className={element.class} key={element.componentId + i}> 
                              <ComponentGroup
                              applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                              key={element.componentId}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              saveApplicationAndCallBi= {props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              ></ComponentGroup>
                            </div>
                          )
                        }else{
                          return (
                              <ComponentGroup
                              applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                              key={element.componentId}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              saveApplicationAndCallBi= {props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              ></ComponentGroup>
                          )
                        }
                        
                      }
                    } else { // TO remove error State when item condition fails
                      element.components.map((subElement) => {
                        if (errorState[subElement.formControlKey]) {
                          setErrorState((prev) => {
                            return ({
                              ...prev,
                              [subElement.formControlKey]: ""
                            })
                          })
                        }
                        if (sectionState.sectionData?.[subElement.formControlKey] && props.sectionId !== "residenceDetailsSection" && (props.sectionId === "CPSpouseCoverDetails" && subElement.formControlKey !== "gender")) {
                          setSectionState((prev) => {
                            return ({
                              ...prev,
                              sectionData: {
                                ...prev.sectionData,
                                [subElement.formControlKey]: ""
                              }
                            })
                          })
                        }
                      })
                    }
                  } else if (element.conditions.length > 1) {
                    if (multiConditionComponentRenderCheck(element.conditions, conditionState, journeyState)) {
                      if(!props.showFirstSectionFields && props.currentSectionIndex === 0 && props.currentPageIndex === 0){
                        if(element.componentId === "CPPersonalDetailName" || element.componentId ===  "email" || element.componentId ===  "contactNo" || element.componentId === "privacypolicy-MD-12-order-25" || element.componentId === "corporateOtp"){
                          return (
                            <div className={element.class} key={element.componentId + i}> 
                              <ComponentGroup
                              applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                              key={element.componentId + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              businessRule = {props.businessRule}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              ></ComponentGroup>
                            </div>
                          )
                        }
                      }else{
                        return (
                          <div className={element.class} key={element.componentId + i}> 
                            <ComponentGroup
                            applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                            key={element.componentId + i}
                            data={element.components}
                            sectionId={props.section.sectionId}
                            pageId={props.pageId}
                            pages={props.pages}
                            currentSectionIndex={props.currentSectionIndex}
                            currentPageIndex={props.currentPageIndex}
                            sections={props.sections}
                            showError={props.showError}
                            businessRule = {props.businessRule}
                            saveApplicationAndCallBi= {props.saveApplicationAndCallBi}
                            journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                            channel={journeyState.channel}
                            firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                            setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                            ></ComponentGroup>
                          </div>
                        )
                      }
                    } else { // TO remove error State when item condition fails
                      element.components.map((subElement) => {
                        if (errorState[subElement.formControlKey]) {
                          setErrorState((prev) => {
                            return ({
                              ...prev,
                              [subElement.formControlKey]: ""
                            })
                          })
                        }
                        if (sectionState.sectionData?.[subElement.formControlKey] && props.sectionId !== "residenceDetailsSection" && (props.sectionId === "CPSpouseCoverDetails" && subElement.formControlKey !== "gender")) {
                          setSectionState((prev) => {
                            return ({
                              ...prev,
                              sectionData: {
                                ...prev.sectionData,
                                [subElement.formControlKey]: ""
                              }
                            })
                          })
                        }
                      })
                    }
                  } else {
                    if (!props.showFirstSectionFields && props.currentSectionIndex === 0 && props.currentPageIndex === 0) {
                      if (element.componentId === "CPPersonalDetailName" || element.componentId === "email" || element.componentId === "contactNo" || element.componentId === "privacypolicy-MD-12-order-25" || element.componentId === "corporateOtp") {
                        if(element.class){
                          return (
                            <div className={element.class} key={element.componentId + i}>
                              <ComponentGroup
                                applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                                key={element.componentId + i}
                                data={element.components}
                                sectionId={props.section.sectionId}
                                pageId={props.pageId}
                                pages={props.pages}
                                currentSectionIndex={props.currentSectionIndex}
                                currentPageIndex={props.currentPageIndex}
                                sections={props.sections}
                                showError={props.showError}
                                nvestFilterResult={props.nvestFilterResult}
                                saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                                journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                                channel={journeyState.channel}
                                firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                                setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                              ></ComponentGroup>
                            </div>
                          )
                        }else{
                          return (
                            <ComponentGroup
                              applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                              key={element.componentId + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                            ></ComponentGroup>
                          )
                        }
                        
                      }
                    } else {
                      if(element.class) {
                        return (
                          <div className={element.class} key={element.componentId + i}>
                            <ComponentGroup
                              applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                              key={element.componentId + i}
                              data={element.components}
                              sectionId={props.section.sectionId}
                              pageId={props.pageId}
                              pages={props.pages}
                              currentSectionIndex={props.currentSectionIndex}
                              currentPageIndex={props.currentPageIndex}
                              sections={props.sections}
                              showError={props.showError}
                              nvestFilterResult={props.nvestFilterResult}
                              saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                              businessRule = {props.businessRule}
                              journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                              channel={journeyState.channel}
                              firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                              setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                            ></ComponentGroup>
                          </div>
                        )
                      }else{
                        return (
                          <ComponentGroup
                            applicationDataInJourneyFormat={props.applicationDataInJourneyFormat}
                            key={element.componentId + i}
                            data={element.components}
                            sectionId={props.section.sectionId}
                            pageId={props.pageId}
                            pages={props.pages}
                            currentSectionIndex={props.currentSectionIndex}
                            currentPageIndex={props.currentPageIndex}
                            sections={props.sections}
                            showError={props.showError}
                            nvestFilterResult={props.nvestFilterResult}
                            saveApplicationAndCallBi={props.saveApplicationAndCallBi}
                            businessRule = {props.businessRule}
                            journeyIdFromStrapi={journeyState.journeyIdFromStrapi}
                            channel={journeyState.channel}
                            firstPassForPremiumPaymentBicall={props.firstPassForPremiumPaymentBicall}
                            setFirstPassForPremiumPaymentBicall={props.setFirstPassForPremiumPaymentBicall}
                          ></ComponentGroup>
                        )
                      }
                      
                    }
                  }
                }
              })}
            </div>
          </div>
        </div>
         { journeyState?.premium && props.pageId == 'calculatePremiumPage' && ['CPResidentAndOccupationDetailSection','CPCustomizePlanSection','CPOptionInBuiltCoversSection','CPSpouseCoverDetails'].includes(props?.section?.sectionId) 
          ? 
          <div className="total-prem-payment-price ">
            <div className="left-line-pre-pay"></div>
            <h2>Total Premium:  &nbsp; ₹ {journeyState.premium}/- {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])}</h2>
          </div>
          : journeyState?.premium && props.pageId == 'PageISelect360CalculatePremium' && ['iSelect360CPResidentAndOccupationDetailSection','iSelect360CPCustomizePlanSection','iSelect360CPOptionalInBuilt','iSelect360CPSpouseCoverDetails'].includes(props?.section?.sectionId) 
          ?
          <div className="total-prem-payment-price ">
            <div className="left-line-pre-pay"></div>
            <h2 id="addMobileMargin">Total Premium:  &nbsp; ₹ {journeyState.premium}/- {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])}</h2>
          </div>
           : journeyState?.premium && props.pageId == 'PageYoungTermCalculatePremium' && ['youngTermCPResidentAndOccupationDetailSection','youngTermCPCustomizePlanSection','youngTermCPOptionalInBuilt','youngTermCPSpouseCoverDetails', 'sectionyoungTermLifeStageEnhancement'].includes(props?.section?.sectionId) 
           ?
           <div className="total-prem-payment-price ">
             <div className="left-line-pre-pay"></div>
             <h2>Total Premium:  &nbsp; ₹ {journeyState.premium}/- {standardCapital(lookup.premiumFrequency[0][journeyState.paymentFrequency])}</h2>
           </div>
          : null
        }
      </div>
        {showModal && (
            <>
              <div style={{
                position : "fixed",
                top : 0,
                left : 0,
                width : "100%",
                height : "100%",
                opacity : 0.5,
                background : "#000",
                zIndex : 1000
              }}>
              </div>
              <div style={{ position: "fixed", top: "40%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(255, 255, 255)", padding: "20px", border: "3px solid #0088c3", borderRadius: "8px", width: "80%", maxWidth: "600px", zIndex: 9999 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                  <h4 style={{ textAlign:"center" , color: "#005575", margin: 0, flex: "1" }}>Non-Standard Age Identity Proof</h4>
                </div>
                <p style={{textAlign:"center", fontSize:"15px"}} >You have chosen a non-standard age identity proof. <br /> Additional Premium will be charged for selecting NSAP proof.</p>
                <button onClick={closeModal} style={{ backgroundColor: "#fec32b", color: "#fff", padding: "8px 16px", border: "none", borderRadius: "4px", cursor: "pointer", display: "block", margin: "0 auto" }}>Ok</button>
              </div>
            </>
        )}
    </>
  )
}

export default Section